"use strict";module.exports = function () {
  // eslint-disable-next-line max-len,quotes
  return '<symbol id=icon-tick-small viewbox="0 0 24 18"><path fill=#0654ba d="M20.429.001L7.673 12.87 2.481 7.677 0 10.386l7.674 7.45L23.14 2.486 20.43 0z"></path></symbol>';
};